// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1XEcS","messages":"Chat_messages__191MI","dateDivider":"Chat_dateDivider__mQRpV"};